#import "../../../../../../core-entity/graphql/fragments/file-fragment.graphql"
fragment ContactAttachmentsFragment on Contact {
    id
    files {
        ...FileFragment
    }
}
